import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useTeamsByStore } from "@coworker/app/src/core/hooks/useStoreTeams";
import { useActiveStoreUsers } from "@coworker/apprestructured/src/shared/hooks/users/useActiveStoreUsers";
import { useMemo } from "react";

type Enableable = { enabled: boolean };

const useActiveUsers = ({ enabled }: Enableable) => {
  const { data: users, isLoading: isActiveUsersLoading } = useActiveStoreUsers(
    undefined,
    { enabled }
  );
  const activeUsers = useMemo(() => users || [], [users]);
  return { activeUsers, isActiveUsersLoading };
};

const useAssignableTeams = ({ enabled }: Enableable) => {
  const storeId = useStoreId();
  const { data: teams, isLoading: isTeamsLoading } = useTeamsByStore(
    storeId || "",
    { enabled: enabled && Boolean(storeId) }
  );
  const assignableTeams = useMemo(
    () => (teams || []).filter((team) => team.status === "ACTIVE"),
    [teams]
  );

  return {
    assignableTeams,
    teams,
    isTeamsLoading,
  };
};

export const useAssignableTeamsAndUsers = ({
  enabled = true,
}: Partial<Enableable> = {}) => {
  const { activeUsers, isActiveUsersLoading } = useActiveUsers({ enabled });
  const { assignableTeams, teams, isTeamsLoading } = useAssignableTeams({
    enabled,
  });
  return {
    activeUsers,
    isActiveUsersLoading,
    assignableTeams,
    teams,
    isTeamsLoading,
  };
};
